/* =============================================
   WISHLIST — ATELIER DE SOAN
   Stockage localStorage
   ============================================= */

(function() {
  var STORAGE_KEY = 'soan_wishlist';

  // --- Helpers ---
  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch(e) { return []; }
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInList(handle) {
    return getList().some(function(p) { return p.handle === handle; });
  }

  function toggle(product) {
    var list = getList();
    var idx = list.findIndex(function(p) { return p.handle === product.handle; });
    if (idx >= 0) { list.splice(idx, 1); }
    else { list.push(product); }
    saveList(list);
    return idx < 0; // true = ajouté
  }

  // --- Mise à jour du compteur header ---
  function updateBadge() {
    var badge = document.getElementById('soan-wishlist-count');
    if (!badge) return;
    var count = getList().length;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }

  // --- Boutons cœur sur les fiches produit ---
  function initProductButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
      var handle = btn.dataset.wishlistHandle;
      updateBtn(btn, isInList(handle));

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var product = {
          handle: handle,
          title: btn.dataset.wishlistTitle,
          price: btn.dataset.wishlistPrice,
          image: btn.dataset.wishlistImage,
          url: btn.dataset.wishlistUrl
        };
        var added = toggle(product);
        updateBtn(btn, added);
        updateBadge();
        showToast(added ? '\u2665 Ajout\u00e9 \u00e0 la wishlist' : '\u2661 Retir\u00e9 de la wishlist');
      });
    });
  }

  function updateBtn(btn, active) {
    var icon = btn.querySelector('.soan-wl-heart');
    if (!icon) return;
    if (active) {
      icon.innerHTML = '\u2665';
      icon.style.color = '#C9A84C';
      btn.setAttribute('aria-label', 'Retirer des favoris');
    } else {
      icon.innerHTML = '\u2661';
      icon.style.color = 'currentColor';
      btn.setAttribute('aria-label', 'Ajouter aux favoris');
    }
  }

  // --- Toast ---
  function showToast(msg) {
    var t = document.getElementById('soan-wl-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'soan-wl-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('soan-wl-toast--visible');
    clearTimeout(t._timeout);
    t._timeout = setTimeout(function() { t.classList.remove('soan-wl-toast--visible'); }, 2000);
  }

  // --- Page wishlist ---
  function renderWishlistPage() {
    var container = document.getElementById('soan-wishlist-page');
    if (!container) return;
    var list = getList();
    if (list.length === 0) {
      container.innerHTML = '<div class="soan-wl-page__empty"><p>\uD83D\uDC94 Votre wishlist est vide</p><a href="/collections/all" class="soan-wl-page__btn">D\u00e9couvrir nos produits</a></div>';
      return;
    }
    container.innerHTML = '<div class="soan-wl-page__grid">' +
      list.map(function(p) {
        return '<div class="soan-wl-page__item">'
          + '<a href="' + p.url + '" class="soan-wl-page__link">'
          + (p.image ? '<img src="' + p.image + '" alt="' + p.title + '" class="soan-wl-page__img">' : '<div class="soan-wl-page__img soan-wl-page__img--empty"></div>')
          + '<p class="soan-wl-page__title">' + p.title + '</p>'
          + '<p class="soan-wl-page__price">' + p.price + '</p>'
          + '</a>'
          + '<button class="soan-wl-page__remove" data-remove="' + p.handle + '">\u2715 Retirer</button>'
          + '</div>';
      }).join('')
      + '</div>';

    container.querySelectorAll('[data-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var list = getList().filter(function(p) { return p.handle !== btn.dataset.remove; });
        saveList(list);
        updateBadge();
        renderWishlistPage();
      });
    });
  }

  // --- Init ---
  document.addEventListener('DOMContentLoaded', function() {
    updateBadge();
    initProductButtons();
    renderWishlistPage();
  });

  window.SoanWishlist = { toggle: toggle, isInList: isInList, getList: getList, updateBadge: updateBadge };
})();
